const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
        borderCollapse: 'unset'
    },
    rootGrid: {
        flexGrow: 1,
    },
    buttons: {
        marginTop: '30px',
        padding: '15px 0 0 15px'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    containerLineOne: {
        display: 'flex',
        flexDirection: 'row',
    },
    containerLineTwo: {
        display: 'block',
        flexDirection: 'row',
    },
    textField: {
        width: '100%',
    },
    filterButton: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
    buttonsRoles: {
        marginTop: '10px',
        padding: '15px 0 0 15px'
    },
    usersTabsLabels: {
        height: 55
    },
    userEditsLead: {
        color: '#666',
        marginTop: '30px',
        paddingBottom: '15px'
    },
    userPermissionsLead: {
        color: '#666',
        marginTop: '30px',
        paddingBottom: '15px'
    },
    userEditsChooseText: {
        paddingBottom: '10px'
    },
    disabledCheckbox: {
        color: 'rgba(0, 88, 61, 0.61)'
    },
    tablePermissionsRow: {
        verticalAlign: 'baseline'
    },
    userPermsTableHeader: {
        fontSize: '0.9rem',
        marginLeft: '20px',
        fontWeight: '700'
    },
    userPermsTableCell: {
        borderRight: '1px solid rgba(0, 0, 0, 0.075)',
        width: '50%',
        '&:last-child': {
            paddingRight: 0,
            borderRight: 'none',
        },
    },
    userPermissions: {
        borderRight: '1px solid rgba(0, 0, 0, 0.075)',
        padding: '0',
    },
    alignText: {
        display: 'inline-block',
        verticalAlign: 'super'
    },
    alignCheckboxes: {
        display: 'inline-block',
    },
    [theme.breakpoints.up('xs')]: {
        userPermsTableCell: {
            padding: '15px',
            '&:last-child': {
                paddingRight: 0,
                borderRight: 'none',
            },
        },
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/users/style/styles.js